module.exports = __webpack_public_path__ + "static/media/changeLog.c7976a54.svg";